import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

/**
 * Carousel styles.
 *
 */

const CarouselWrapper = styled.div`
  .carousel__slide {
    position: relative;
    display: block;
    box-sizing: border-box;
    height: 0;
    margin: 0;
    list-style-type: none;
    padding-right: 35px;
    transition: all 500ms ease-in-out;

    @media (min-width: ${fullConfig.theme.screens.md}) {
      padding-right: 0;
    }

    &--visible {
      margin-right: -35px;

      @media (min-width: ${fullConfig.theme.screens.md}) {
        margin-right: 0;
      }
    }
  }
  .carousel__slide:focus {
    outline: none !important;
  }
  li[class*=' slideHorizontal___'] {
    float: left;
  }
  [dir='rtl'] li[class*=' slideHorizontal___'] {
    direction: rtl;
    transform: scaleX(-1);
  }
  .carousel__inner-slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .carousel__slider--horizontal {
    position: relative;
    overflow: hidden;
  }
  [dir='rtl'] .carousel__slider--horizontal {
    direction: ltr;
    transform: scaleX(-1);
  }

  .carousel__slider-tray--horizontal {
    display: block;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .carousel__slider-tray {
    transition: transform 0.5s;
    // transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    will-change: transform;
  }

  /* Dot and Dot group */
  .carousel__dot {
    border-radius: 9999px;
    background-color: ${fullConfig.theme.extend.colors.basic['400']};
    height: 10px;
    width: 10px;
    margin-right: 5px;
  }

  .carousel__dot--selected {
    background-color: ${fullConfig.theme.extend.colors.primary.default};
  }
`;

// eslint-disable-next-line
export { CarouselWrapper };
